'use client';

import { Suspense, useEffect, useState } from 'react';

import { SliceZone } from '@prismicio/react';
import { getComponents } from '@/slices/component-factory';
import StarfieldBackground from '@/components/StarfieldBackground';
import BlogPreloader from '@/components/blogHome/BlogPreloader';
import {
  BlogCategoryDocument,
  BlogHomeLayoutDocumentDataSlicesSlice,
} from '../../../../prismicio-types';

interface BlogPageClientProps {
  decorativeSlices: BlogHomeLayoutDocumentDataSlicesSlice[];
  context: {
    categories: BlogCategoryDocument[];
    category?: string;
    readBlog?: string;
    hubspotPortalIdForm: unknown;
    page: number;
  };
}

export default function BlogPageClient({
  decorativeSlices,
  context,
}: BlogPageClientProps) {
  const [shouldRenderSlices, setShouldRenderSlices] = useState(false);

  useEffect(() => {
    // Defer decorative slices until after page load and a short delay
    const timer = setTimeout(() => {
      setShouldRenderSlices(true);
    }, 1500); // 1.5s delay to ensure critical content loads first

    return () => clearTimeout(timer);
  }, []);

  // Get blog-specific components
  const blogComponents = getComponents(true);

  return (
    <>
      {/* Client-side preloading component - only runs in browser */}
      <BlogPreloader category={context.category} page={context.page} />

      <StarfieldBackground />

      {/* Reserve space immediately but defer actual rendering */}
      <div
        className={shouldRenderSlices ? '' : 'min-h-[400px] md:min-h-[500px]'}
      >
        {shouldRenderSlices && decorativeSlices.length > 0 && (
          <Suspense fallback={null}>
            <SliceZone
              slices={decorativeSlices}
              components={blogComponents}
              context={context}
            />
          </Suspense>
        )}
      </div>
    </>
  );
}
